export const VL_ONLY_GUIDE_CONFIG = ['shortTimeLabels'];
export const VL_ONLY_LEGEND_CONFIG = [
    'gradientHorizontalMaxLength',
    'gradientHorizontalMinLength',
    'gradientVerticalMaxLength',
    'gradientVerticalMinLength'
];
//# sourceMappingURL=guide.js.map